import React, { FC, useState } from 'react';
import { Switch, Text } from 'snacks-design-system';
import styles from './PIESwitch.module.scss';

interface IPropsPieSwitch {
  label?: string;
  labelPosition?: 'left' | 'right';
  setOnByDefault?: boolean;
  onAction?: () => void;
  onChange: ({ isSwitchOn }: { isSwitchOn: boolean }) => void;
}

export const PIESwitch: FC<IPropsPieSwitch> = ({
  label,
  onChange,
  setOnByDefault = undefined,
  labelPosition,
}) => {
  /* Component State */
  const [isSwitchOn, setIsSwitchOn] = useState(setOnByDefault);

  /* Action Handlers */

  const handleOnChange = (evt: any) => {
    setIsSwitchOn(evt.target.checked);
    onChange({ isSwitchOn: evt.target.checked });
  };

  return (
    <div className={styles.container}>
      {label && labelPosition === 'left' ? (
        <Text size="var(--xds-font-size-16)">{label}</Text>
      ) : null}
      <Switch checked={isSwitchOn} onChange={handleOnChange} />
      {label && labelPosition === 'right' ? (
        <Text size="var(--xds-font-size-16)">{label}</Text>
      ) : null}
    </div>
  );
};

export default PIESwitch;
